/*
 * Lieferdatum-Berechnung
 * Rechnet ab heute N Werktage vorwärts und überspringt dabei Wochenenden
 * sowie gesetzliche Feiertage in Bayern. Das Ergebnis wird in jedes Element
 * mit [data-delivery-days] geschrieben (deutsches Datumsformat).
 * Traegt das Element zusaetzlich [data-delivery-days-min] (kleiner als
 * data-delivery-days), wird eine Spanne geschrieben: "Mi., 28.10. und Di., 03.11."
 * (Bindewort aus data-range-joiner). Die Kurzformen landen in data-date-from /
 * data-date-to, die Kaufbox der Pure Line baut daraus ihre Zusagen-Zeile.
 */
(function () {
  'use strict';

  // Ostersonntag (Meeus/Jones/Butcher-Algorithmus) als Basis für die
  // beweglichen Feiertage.
  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31); // 3 = März, 4 = April
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function key(date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }

  // Gesetzliche Feiertage für ein Jahr, je Zielland.
  // 'DE' = Bayern (Versandstandort). 'AT' = Österreich, bundesweit.
  // Unbekanntes Land fällt auf 'DE' zurück, damit nie zu wenige Feiertage gezählt werden
  // und das versprochene Datum nicht zu optimistisch ausfällt.
  function holidaysFor(year, region) {
    var set = {};
    function add(date) { set[key(date)] = true; }
    var easter = easterSunday(year);

    // In beiden Ländern gesetzlicher Feiertag
    add(new Date(year, 0, 1));   // Neujahr
    add(new Date(year, 0, 6));   // Heilige Drei Könige
    add(new Date(year, 4, 1));   // Tag der Arbeit / Staatsfeiertag
    add(new Date(year, 7, 15));  // Mariä Himmelfahrt
    add(new Date(year, 10, 1));  // Allerheiligen
    add(new Date(year, 11, 25)); // 1. Weihnachtstag / Christtag
    add(new Date(year, 11, 26)); // 2. Weihnachtstag / Stefanitag
    add(addDays(easter, 1));     // Ostermontag
    add(addDays(easter, 39));    // Christi Himmelfahrt
    add(addDays(easter, 50));    // Pfingstmontag
    add(addDays(easter, 60));    // Fronleichnam

    if (region === 'AT') {
      add(new Date(year, 9, 26)); // Nationalfeiertag
      add(new Date(year, 11, 8)); // Mariä Empfängnis
      // Karfreitag ist in Österreich KEIN allgemeiner Feiertag, der 3. Oktober auch nicht.
    } else {
      add(new Date(year, 9, 3));  // Tag der Deutschen Einheit
      add(addDays(easter, -2));   // Karfreitag
    }

    return set;
  }

  var holidayCache = {};
  function isHoliday(date, region) {
    var k = region + ':' + date.getFullYear();
    if (!holidayCache[k]) holidayCache[k] = holidaysFor(date.getFullYear(), region);
    return !!holidayCache[k][key(date)];
  }

  function isBusinessDay(date, region) {
    var weekday = date.getDay();
    if (weekday === 0 || weekday === 6) return false; // Sonntag / Samstag
    return !isHoliday(date, region);
  }

  // Addiert N Werktage zum Startdatum.
  function addBusinessDays(start, n, region) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d = addDays(d, 1);
      if (isBusinessDay(d, region)) added++;
    }
    return d;
  }

  var WEEKDAYS = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatDate(date) {
    return WEEKDAYS[date.getDay()] + ', ' + pad(date.getDate()) + '.' + pad(date.getMonth() + 1) + '.' + date.getFullYear();
  }

  // Ohne Jahr: In einer Spanne waere es doppelt und macht die Zeile zu lang.
  function formatShort(date) {
    return pad(date.getDate()) + '.' + pad(date.getMonth() + 1) + '.';
  }

  function formatDay(date) {
    return WEEKDAYS[date.getDay()] + ', ' + formatShort(date);
  }

  function render(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.wb-delivery-date[data-delivery-days]');
    if (!nodes.length) return;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    Array.prototype.forEach.call(nodes, function (node) {
      var days = parseInt(node.getAttribute('data-delivery-days'), 10);
      if (isNaN(days) || days < 0) return;
      var region = node.getAttribute('data-holiday-region') === 'AT' ? 'AT' : 'DE';
      var target = days === 0 ? today : addBusinessDays(today, days, region);

      var minDays = parseInt(node.getAttribute('data-delivery-days-min'), 10);
      if (!isNaN(minDays) && minDays >= 0 && minDays < days) {
        var from = minDays === 0 ? today : addBusinessDays(today, minDays, region);
        var joiner = node.getAttribute('data-range-joiner') || '–';
        node.setAttribute('data-date-from', formatShort(from));
        node.setAttribute('data-date-to', formatShort(target));
        node.textContent = formatDay(from) + ' ' + joiner + ' ' + formatDay(target);
        return;
      }

      node.textContent = formatDate(target);
    });
  }

  function init() { render(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Nach AJAX-Re-Renders (Theme-Editor / Variantenwechsel) neu berechnen.
  document.addEventListener('shopify:section:load', function (e) { render(e.target); });
})();
